import { useCallback, useEffect, useState } from "react";
import { Trash2, Paperclip } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, BACKEND } from "../../lib/api";
import { DICT } from "../../i18n/dict";

const TYPES = DICT.it.contact.types;
const STATUS = { new: "Nuova", in_progress: "In lavorazione", closed: "Chiusa" };

const Row = ({ k, v }) => v ? <div className="grid grid-cols-3 gap-3 py-1.5"><dt className="text-[#555555] text-xs uppercase tracking-wider">{k}</dt><dd className="col-span-2 text-sm whitespace-pre-line">{v}</dd></div> : null;

export const EnquiriesAdmin = () => {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/enquiries"); setList(Array.isArray(data) ? data : []); }
    catch (e) { toast.error(errMsg(e, "Errore")); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (e, status) => { await api.patch(`/admin/enquiries/${e.id}`, { status }); load(); };
  const remove = async (e) => { if (!window.confirm("Eliminare questa richiesta?")) return; await api.delete(`/admin/enquiries/${e.id}`); load(); };

  if (!list.length) return <p className="text-[#555555]" data-testid="admin-enquiries-empty">Nessuna richiesta ricevuta.</p>;

  return (
    <section className="border-t border-[#1A1A1A]/12" data-testid="admin-enquiries">
      {list.map((e) => (
        <article key={e.id} className="border-b border-[#1A1A1A]/10" data-testid={`enquiry-${e.id}`}>
          <button type="button" onClick={() => setOpen(open === e.id ? null : e.id)} className="w-full grid grid-cols-12 gap-4 py-4 text-left items-center">
            <span className="col-span-12 sm:col-span-2 f-mono text-xs text-[#555555]">{new Date(e.created_at).toLocaleString("it-IT")}</span>
            <span className="col-span-6 sm:col-span-3 font-medium">{e.name}</span>
            <span className="col-span-6 sm:col-span-3 text-sm">{TYPES[e.project_type]}{e.stone_code && <span className="f-mono text-xs ml-2">{e.stone_code}</span>}</span>
            <span className="col-span-6 sm:col-span-2 text-xs">{STATUS[e.status]}</span>
            <span className={`col-span-6 sm:col-span-2 text-xs ${e.email_status === "sent" ? "text-[#5d6b4f]" : "text-[#8a3b2e]"}`}>{e.email_status === "sent" ? "Email inviata" : "Email non inviata"}</span>
          </button>
          {open === e.id && (
            <div className="pb-6 grid grid-cols-1 lg:grid-cols-12 gap-8">
              <dl className="lg:col-span-8">
                <Row k="Email" v={<a href={`mailto:${e.email}`} className="underline">{e.email}</a>} />
                <Row k="Paese" v={e.country} /><Row k="Pietra" v={[e.stone_code, e.stone_name].filter(Boolean).join(" — ")} />
                <Row k="Dimensioni" v={e.dimensions} /><Row k="Destinazione" v={e.intended_use} />
                <Row k="Budget" v={e.budget} /><Row k="Tempistiche" v={e.timeline} /><Row k="Lingua" v={e.lang?.toUpperCase()} />
                <Row k="Descrizione" v={e.description} />
                {e.attachments?.length > 0 && <Row k="Allegati" v={<span className="flex flex-col gap-1">{e.attachments.map((p, i) => <a key={p} href={`${BACKEND}/api/files/${p}`} target="_blank" rel="noreferrer" className="underline inline-flex items-center gap-2"><Paperclip className="w-3 h-3" />File {i + 1}</a>)}</span>} />}
              </dl>
              <div className="lg:col-span-4 flex lg:flex-col gap-3 items-start">
                <select className="field !py-1 text-sm" value={e.status} onChange={(ev) => setStatus(e, ev.target.value)} data-testid={`enquiry-status-${e.id}`}>
                  {Object.entries(STATUS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                </select>
                <button type="button" onClick={() => remove(e)} className="text-[#8a3b2e] text-xs inline-flex items-center gap-2 py-2"><Trash2 className="w-4 h-4" strokeWidth={1.25} />Elimina</button>
              </div>
            </div>
          )}
        </article>
      ))}
    </section>
  );
};
